import React from "react";
import { getValue } from "@utils/lodash";

function MoreConfigSvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        viewBox="0 0 24 24"
      >
        <defs>
          <clipPath id="clip-path6">
            <rect
              id="Rectangle_18186"
              data-name="Rectangle 18186"
              width="24"
              height="24"
              transform="translate(-14547 -8430)"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Mask_Group_294"
          data-name="Mask Group 294"
          transform="translate(14547 8430)"
          clipPath="url(#clip-path6)"
        >
          <path
            id="tune_FILL0_wght300_GRAD0_opsz24"
            d="M12.686-10.457v-5.657h1.543v2.057h8.229v1.543H14.229v2.057H12.686ZM4.457-12.514v-1.543h5.657v1.543Zm4.114-4.114v-2.057H4.457v-1.543H8.571v-2.057h1.543v5.657H8.571Zm4.114-2.057v-1.543h9.771v1.543H12.686ZM16.8-22.8v-5.657h1.543V-26.4h4.114v1.543H18.343V-22.8ZM4.457-24.857V-26.4h9.771v1.543H4.457Z"
            transform="translate(-14548.457 -8398.543)"
            fill={
                getValue(props, `color`, "")
                  ? getValue(props, `color`, "")
                  : "#5f6368"
              }
          />
        </g>
      </svg>
    </div>
  );
}

export default MoreConfigSvgComponent;
